import { render, staticRenderFns } from "./newOne.vue?vue&type=template&id=af19bbc4&scoped=true&"
import script from "./newOne.vue?vue&type=script&lang=js&"
export * from "./newOne.vue?vue&type=script&lang=js&"
import style0 from "./newOne.vue?vue&type=style&index=0&id=af19bbc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af19bbc4",
  null
  
)

export default component.exports